import { useState } from "react";
import "./ProductsModule.scss";
import { ProductsLoadingAnimation } from "../animations/ProductsLoadingAnimation/ProductsLoadingAnimation";
import { ProductPage } from "./ProductPage/ProductPage";

export const ProductsModule = ({ aiResults, getProducts, onBackClick }) => {
  const [productsData, setProductsData] = useState(undefined);
  const [step, setStep] = useState(0);

  return (
    <>
      {step === 0 && (
        <ProductsLoadingAnimation
          apiPromise={() =>
            getProducts().then((resData) => setProductsData(resData))
          }
          onFinish={() => setStep(1)}
        />
      )}
      {productsData !== undefined && productsData !== null && step === 1 && (
        <ProductPage
          results={aiResults}
          recommendedData={productsData}
          onBackClick={onBackClick}
        />
      )}
    </>
  );
};
